import React from 'react'
import WhyChooseCard from '../WhyChooseCard/WhyChooseCard';
import { Col, Container, Row } from 'react-bootstrap';
import './WhyChoose.css';
const WhyChoose = ({ whyChooseContent, whyChooseContentHeading = "" , page= ""}) => {
    const items = whyChooseContent || [
        { icon: "/icons/luxury-experience.png", title: "Luxury Experience" },
        { icon: "/icons/certified-experts.png", title: "Certified Experts" },
        { icon: "/icons/premium-lens-techno.png", title: "Premium Lens Technology" },
        { icon: "/icons/exclusive-eyewear-brand.png", title: "Exclusive Eyewear Brands" },
    ];
    const heading = whyChooseContentHeading !== "" ? whyChooseContentHeading : { heading: "Why Choose ", headingGold: "Elite Optix" };
    return (
        <section className="why-choose-section">
            <Container>
                <h2 className="why-choose-heading">
                    {heading.heading} <span>{" " + heading.headingGold}</span>
                </h2>
                {page === "about" && <p className="why-choose-subtitle text-center mb-4">Discover the Elite Optix difference – where expert care meets luxury eyewear for an unparalleled vision experience.</p>}
                <Row className="justify-content-center">
                    {items.map((item, index) => (
                        
                        <Col key={index} md={3} sm={6} xs={12} className="mb-4">
                            <WhyChooseCard icon={item.icon} title={item.title} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default WhyChoose